import { NgModule } from "@angular/core";
import { TwoDecimalPlacesDirective } from './directives/two-decimal-number.directive';  
import { NumberOnlyDirective } from './directives/number-only.directive'; 
@NgModule({
    declarations :[
        TwoDecimalPlacesDirective, 
        NumberOnlyDirective
    ],
    exports:[
        TwoDecimalPlacesDirective, 
        NumberOnlyDirective
    ]
})

export class SharedModule{

}